import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, ShieldCheck, Quote } from "lucide-react";
import { api } from "@/lib/api";
import { BorrowerForm } from "@/components/BorrowerForm";

const POINTS = ["Independent, third-party feasibility analysis", "Market, site and financial projections with break-even and ROI", "Lender-ready PDF and Word delivery", "No obligation: we confirm scope and price first"];

export default function InvitedRequest() {
  const { token } = useParams();
  const [inv, setInv] = useState(null);
  const [error, setError] = useState(false);
  const [tier, setTier] = useState("");
  useEffect(() => { api.get(`/public/form-invites/${token}`).then((r) => { setInv(r.data); setTier(r.data.tier || ""); }).catch(() => setError(true)); }, [token]);
  if (error) return <div className="min-h-[60vh] grid place-items-center text-slate-400" data-testid="invite-not-found">This invitation link is not valid.</div>;
  if (!inv) return <div className="min-h-[60vh] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>;
  return (
    <div className="grid-bg" data-testid="invited-request-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 fade-up">
          <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold mb-4">Invitation from {inv.company_name}</p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05] mb-5" data-testid="invite-greeting">Hi {inv.name.split(" ")[0]}, let's scope your <span className="text-emerald-400">feasibility study</span>.</h1>
          {inv.note && <blockquote className="relative rounded-xl border border-slate-800 bg-slate-900/70 p-5 pl-12 text-slate-300 mb-6" data-testid="invite-note-text"><Quote className="absolute left-4 top-5 h-5 w-5 text-emerald-400" />{inv.note}<footer className="mt-2 text-xs text-slate-500">— {inv.invited_by}</footer></blockquote>}
          {inv.submitted && <p className="text-sm text-amber-300 mb-6" data-testid="invite-already-submitted">You've already sent a request with this link. Feel free to send another if something changed.</p>}
          <ul className="space-y-3">{POINTS.map((x) => <li key={x} className="flex gap-3 text-sm text-slate-300"><ShieldCheck className="h-5 w-5 shrink-0 text-emerald-400" />{x}</li>)}</ul>
        </div>
        <div className="lg:col-span-7">
          <BorrowerForm tier={tier} setTier={setTier} inviteToken={token} initial={{ name: inv.name, email: inv.email }} />
        </div>
      </div>
    </div>
  );
}
